import { createSlice } from "@reduxjs/toolkit";
import {
  Error,
  Success,
} from "../../components/UIResuableComponents/Error/ErrorSuccess";
const authSlice = createSlice({
  name: "auth",
  initialState: {
    userAuth: true,
  },
  reducers: {
    login: (state, action) => {
      const authValue = state.userAuth;
      state.userAuth = !authValue;
      state.message = action.payload.message;
      state.isError = action.payload.isError;
    },
    logout: (state) => {
      state.userAuth = !state.userAuth;
      state.message = "Successfully logout";
      state.isError = "success";
    },
  },
});

export const authAction = authSlice.actions;

//login async task
export function loginUser() {
  return async (dispatch) => {
    try {
      Success("Successfully logged in");
      dispatch(authAction.login({ message: "success", isError: true }));
    } catch (e) {
      dispatch(authAction.login({ message: "error", isError: false }));
      Error("Error Occur");
    }
  };
}

export default authSlice.reducer;
